export interface Activity {
  id: number;
  title: string;
  description: string;
  ageRange: string;
  date: string;
  type: string;
  image: string;
}

export const activities: Activity[] = [
  {
    id: 1,
    title: "Atelier Peinture Créative",
    description: "Venez explorer les couleurs et les textures dans un atelier ludique adapté aux enfants de tous âges.",
    ageRange: "3-7 ans",
    date: "5 mai 2025",
    type: "Artistique",
    image: "/src/assets/images/activity1.jpg"
  },
  {
    id: 2,
    title: "Découverte Musicale",
    description: "Initiez vos enfants aux instruments de musique et au rythme dans un environnement amusant et interactif.",
    ageRange: "4-8 ans",
    date: "12 mai 2025",
    type: "Musique",
    image: "/src/assets/images/activity2.jpg"
  },
  {
    id: 3,
    title: "Aventure Nature",
    description: "Une exploration de la biodiversité locale pour sensibiliser les enfants à l'environnement tout en s'amusant.",
    ageRange: "5-10 ans",
    date: "19 mai 2025",
    type: "Plein air",
    image: "/src/assets/images/activity3.jpg"
  },
  {
    id: 4,
    title: "Contes et Histoires",
    description: "Une heure de contes et d'histoires interactives qui stimuleront l'imagination de vos enfants.",
    ageRange: "3-6 ans",
    date: "26 mai 2025",
    type: "Culturel",
    image: "/src/assets/images/activity1.jpg"
  },
  {
    id: 5,
    title: "Initiation au Théâtre",
    description: "Permettez à vos enfants de découvrir l'art du théâtre à travers des jeux et des exercices adaptés.",
    ageRange: "6-12 ans",
    date: "2 juin 2025",
    type: "Théâtre",
    image: "/src/assets/images/activity2.jpg"
  },
  {
    id: 6,
    title: "Jeux Sportifs Coopératifs",
    description: "Des activités sportives adaptées qui favorisent la coopération et le développement moteur.",
    ageRange: "4-10 ans",
    date: "9 juin 2025",
    type: "Sport",
    image: "/src/assets/images/activity3.jpg"
  }
];
